import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from '../auth.service';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ngx-captcha';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  error;
  capchaKey = environment.capchaKey;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private reCaptchaV3Service: ReCaptchaV3Service
  ) {
    this.reCaptchaV3Service.execute(
      environment.capchaKey,
      'homepage',
      token => {
        console.log('This is your token: ', token);
        this.resetPasswordForm.get('recaptchaKey').patchValue(token);
      },
      {
        useGlobalDomain: true
      }
    );
  }

  ngOnInit() {
    this.resetPasswordForm = this.formBuilder.group({
      email: ['', Validators.required],
      recaptchaKey: ['', Validators.required]
    });
  }

  handleSuccess(event) {
    console.log(event);
  }

  onSubmit() {
    if (this.resetPasswordForm.valid) {
      this.authService.resetPassword(this.resetPasswordForm.value.email, this.resetPasswordForm.value.recaptchaKey).subscribe(
        data => {
          console.log(data);
          if (data === null || data.status === 200) {
            this.router.navigate(['/auth'], { queryParams: { sendPassword: true } });
          }
        },
        err => {
          console.error(err);
          if (err.message === 'User not found') {
            this.error = 'Nie znaleziono użytkownika.';
          }
        }
      );
    }
  }
}
